import { RoleEnum } from '../enums/role';
import { HR_PERMISSION_ROUTE } from '../routes/permissions/HR';
import { ADMIN_PERMISSION_ROUTES } from '../routes/permissions/admin';

export const checkPermission = (roleType: string, pathRoute: string): boolean => {
  if (roleType === RoleEnum.SUPER_ADMIN) {
    return true;
  } else if (roleType === RoleEnum.ADMIN) {
    return ADMIN_PERMISSION_ROUTES.includes(pathRoute);
  } else if (roleType === RoleEnum.HR) {
    return HR_PERMISSION_ROUTE.includes(pathRoute);
  } else {
    return false;
  }
};
